// extracted by mini-css-extract-plugin
export var column = "_vg-0";
export var divider = "_vg-2";
export var timePicker = "_vg-1";